import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Components } from "@thisgorilla/primate-ds";
import { useAppSelector } from "../../../../redux";
import { ArticleProps } from "../../../../redux/slices/article/Article";
import { ContentProps } from "./Content";
import { ButtonContainer, ContentContainer } from "./style";
import { renderContent } from "./utils";

export const SortableItem = ({ id }: ContentProps.CommonProps) => {
  const { body_content } = useAppSelector(
    (state) => state.article.draftArticle
  );
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(
      transform ? { ...transform, scaleY: 1 } : transform
    ),
    transition,
    width: "950px",
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    marginRight: "44px",
  };

  return (
    <div ref={setNodeRef} style={style}>
      <ButtonContainer {...attributes} {...listeners}>
        <Components.IconButton
          disabled={false}
          iconType="Move"
          kind="Secondary"
          onClick={() => {}}
          size="Small"
        />
      </ButtonContainer>
      <ContentContainer>
        {renderContent(
          body_content.find((item) => item.id === id) as ArticleProps.Content
        )}
      </ContentContainer>
    </div>
  );
};
